module.exports = __webpack_public_path__ + "img/revenues-Export.94bb5a3e.png";